import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material/styles";
import FusePageSimple from "@fuse/core/FusePageSimple";
import FuseNavigation from "@fuse/core/FuseNavigation";
import { useThemeMediaQuery } from "@fuse/hooks";
import Card from "@mui/material/Card";
import { motion } from "framer-motion";
import YouthSelectGroup from "app/shared-components/YouthSelectGroup";

const Root: any = styled(FusePageSimple)(({ theme }) => ({
  "& .FusePageSimple-header": {
    backgroundColor: theme.palette.background.paper,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.divider,
    "& > .container": {
      maxWidth: "100%",
    },
  },
}));

const greenBadge = {
  title: " ✓",
  classes: "px-5 bg-green text-on-secondary rounded-full",
};

const navigationData = [
  {
    id: "actions-group",
    title: "Actions",
    type: "group",
    children: [
      {
        id: "career-preference",
        title: "Career Preference",
        type: "item",
        icon: "heroicons-solid:star",
        url: "career-interest",
        badge: greenBadge,
      },
      {
        id: "resume",
        title: "Resume",
        type: "item",
        icon: "heroicons-outline:document",
        url: "application-resume",
        badge: greenBadge,
      },
      {
        id: "parent-consent",
        title: "Parent Consent",
        type: "item",
        icon: "heroicons-outline:check",
        url: "parent-consent-form",
        badge: greenBadge,
      },
      {
        id: "proof-of-age",
        title: "Proof of Age",
        type: "item",
        icon: "heroicons-outline:calendar",
        url: "proof-of-age",
        badge: greenBadge,
      },
      {
        id: "proof-of-residency",
        title: "Proof of Residency",
        type: "item",
        icon: "heroicons-outline:home",
        url: "proof-of-residency",
        badge: greenBadge,
      },
      {
        id: "proof-of-ssn",
        title: "Proof of SSN",
        type: "item",
        icon: "heroicons-outline:map",
        url: "proof-of-ssn",
        badge: greenBadge,
      },
      {
        id: "proof-of-work",
        title: "Proof of Work",
        type: "item",
        icon: "heroicons-outline:briefcase",
        url: "proof-of-work",
        badge: greenBadge,
      },
      {
        id: "transportation",
        title: "Transportation",
        type: "item",
        icon: "heroicons-outline:truck",
        url: "transportation",
        badge: greenBadge,
      },
    ],
  },
];

export default function ParentJobApplication() {
  const isMobile = useThemeMediaQuery((theme: any) =>
    theme.breakpoints.down("lg")
  );

  const [leftSidebarOpen, setLeftSidebarOpen] = useState(!isMobile);

  useEffect(() => {
    setLeftSidebarOpen(!isMobile);
  }, [isMobile]);

  return (
    <Root
      header={
        <div className="flex flex-col bg-white m-10">
          <YouthSelectGroup
            onProgramChange={() => {}}
            onYouthChange={() => {}}
          />
        </div>
      }
      content={
        <Card variant="outlined" className="m-24 w-full">
          <div className="m-24">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1, transition: { delay: 0.2 } }}
            >
              <Outlet></Outlet>
            </motion.div>
          </div>
        </Card>
      }
      leftSidebarContent={
        <div className="px-12 py-24 min-h-6xl">
          <div className="mx-12 text-3xl font-bold tracking-tighter">
            Job Application
          </div>
          <FuseNavigation navigation={navigationData} />
        </div>
      }
      leftSidebarOpen={leftSidebarOpen}
      scroll="content"
    />
  );
}
